import { loggedInUser } from 'hooks/use-logged-in-user';
import { useOrgService } from 'hooks/services/use-org-service';
import { useQuery } from '@tanstack/react-query';
import { IDepartment } from 'types';

interface DepartmentsCache {
  departments: IDepartment[];
  isDepartmentsLoading: boolean;
  hasDepartments: boolean;
}

export const useDepartmentsCache = (): DepartmentsCache => {
  const orgService = useOrgService();
  const { isLoggedIn } = loggedInUser.useController();

  const departmentsQuery = useQuery({
    queryKey: ['departments'],
    queryFn: () => orgService.getSollisDepartments(),
    staleTime: Infinity,
    enabled: isLoggedIn
  });

  const { isLoading: isDepartmentsLoading, data: departments = [] } = departmentsQuery;

  return {
    isDepartmentsLoading,
    departments,
    hasDepartments: departments.length > 0
  };
};
